import { CalloutBanner, Icon, Text } from "@growtherapy/sprout-ui";
import { CTAProps } from "./PreSessionPrompt";
import { faPenLine } from "@fortawesome/pro-regular-svg-icons";
import { VisitorDrawerState } from "../../state";
import { VisitorDrawerButton } from "../../VisitorDrawerButton";
import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from "../../constants";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { MEASURES_CTA_BUTTON_TEXT, MEASURES_CTA_INTRO_TEXT } from "./lang";

export function ClientMeasuresCta({ openDrawer }: CTAProps) {
  return (
    <CalloutBanner
      use="lilac"
      className="border-none w-fit"
      heading="Take this time for a mental health check-in"
      headingAs="h2"
      headingVariant="md"
      icon={faPenLine}
      data-testid="pre-session-prompt-client-measures"
    >
      <div className="flex flex-col gap-y-4">
        <Text>{MEASURES_CTA_INTRO_TEXT}</Text>
        <VisitorDrawerButton
          closedAriaLabel="Open check-in survey"
          openedAriaLabel="Close check-in survey"
          drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
          forDrawerStates={VisitorDrawerState.PENDING_FORMS}
          className="flex gap-4 justify-center items-center w-full"
          onClick={() => openDrawer(VisitorDrawerState.PENDING_FORMS)}
        >
          <span>{MEASURES_CTA_BUTTON_TEXT}</span>
          <Icon aria-hidden icon={faChevronRight} />
        </VisitorDrawerButton>
      </div>
    </CalloutBanner>
  );
}
